module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 4mcu
// module chunks = 61 62 63 64 65 66 67 68 69 70 71 72 73 74 75